import React from 'react';
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import './style.scss';

export default function Popups() {
  const [popupVisible, setPopupVisible] = React.useState(false);
  const showInfo = () => {
    setPopupVisible(true);
  }
  const hideInfo = () => {
    setPopupVisible(false);
  }
  const okButtonOptions = {
    icon: 'save',
    text: 'Save',
    type: 'default',
    onClick: hideInfo,
  };
  const cancelButtonOptions = {
    text: 'Cancel',
    type: 'normal',
    onClick: hideInfo,
  };
  return (
    <React.Fragment>
      <Button
          className="button-info"
          text="Popup"
          onClick={showInfo}
      />
      <Popup
          visible={popupVisible}
          onHiding={hideInfo}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="Information"
        >
          <Position
            at="center"
            my="center"
            of=""
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={cancelButtonOptions}
          />
          <ToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            options={okButtonOptions}
          />
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi et velit accumsan lectus posuere tincidunt. Praesent pulvinar, sem et blandit malesuada, eros lacus gravida magna, sit amet interdum est purus ut ante. Sed molestie vitae mauris ac fringilla. Morbi sit amet neque mollis, hendrerit erat non, dictum dui. Maecenas turpis nisi, placerat eget fermentum et, dapibus sit amet ligula. Sed luctus bibendum magna non volutpat. In vulputate nec dolor sit amet interdum. Sed imperdiet tristique malesuada. Mauris vitae pellentesque lectus. Duis et libero at ipsum vulputate elementum.</p>
          <p>Curabitur molestie porta tincidunt. Vivamus commodo est vitae metus sollicitudin sagittis. Donec fermentum, sem in cursus viverra, risus purus luctus diam, quis mollis eros nibh a dolor. Donec pharetra augue arcu, vitae aliquam ipsum tempus quis. Aliquam nulla nisl, egestas ut nisl at, eleifend tristique sem. Morbi molestie quam nunc, commodo dignissim lectus tempor in. Nunc pretium volutpat efficitur.</p>
        </Popup>
    </React.Fragment>
)}
